import approvalStatuses from "./constants/approvalStatuses";

export default function isDenied(data) {
	return data?.approval?.status === approvalStatuses.DENIED;
}
